/**
 * Privacy policy. Public: Google Play requires a policy URL reachable without signing in,
 * and a reviewer opens it with no account at all. See main.js PUBLIC_ROUTES.
 *
 * Everything here is a statement about the live system, so it has to be kept true: the
 * services named are the ones the stacks actually use (see v2/CLAUDE.md), and the retention
 * periods are the ones configured in infra (Aurora backups 7 days, API access logs 3 months).
 */

const UPDATED = '19 September 2026';

export function renderPrivacy() {
    document.getElementById('app').innerHTML = `
        <div class="container">
            <div class="section-header"><h1>Privacy policy</h1></div>
            <p class="text-muted">Last updated: ${UPDATED}</p>

            <section class="form-section">
                <h2>Who this is for</h2>
                <p>The Shanks Family Portal is a private, invite-only website and app for one family.
                   There is no public sign-up: accounts are created by a family administrator. It is
                   run by the family for the family, and not as a business.</p>
                <p>If you have any question about your information, email
                   <a href="mailto:rob@shanksfamily.net">rob@shanksfamily.net</a>.</p>
            </section>

            <section class="form-section">
                <h2>What is stored</h2>
                <ul>
                    <li><strong>Your account:</strong> your name, your email address, and your sign-in
                        credentials. Passwords are held by Amazon Cognito and are never visible to us.
                        Two-factor sign-in is optional.</li>
                    <li><strong>Photos and videos</strong> you upload, with their captions and
                        collections, and who you have shared each one with.</li>
                    <li><strong>Events</strong> you create, and what guests add to them: their name and
                        email address, their photos and videos, guest-book messages and voice notes.</li>
                    <li><strong>Security records:</strong> sign-in events, and the network (IP) address
                        of requests. An event guest's last-seen address is shown to that event's
                        organiser, so they can block a guest who misuses the page.</li>
                </ul>
            </section>

            <section class="form-section">
                <h2>How it is used</h2>
                <p>Your information is used to run the portal and nothing else. It is never sold, and
                   never used for advertising. There is no advertising, no tracking and no analytics
                   in the website or the app.</p>
            </section>

            <section class="form-section">
                <h2>Where it is held, and who else sees it</h2>
                <p>Everything is stored on Amazon Web Services in Ireland (eu-west-1). AWS provides
                   the hosting, the database, file storage, sign-in and malware scanning of uploads.
                   Email — invitations, password resets and event codes — is sent through Amazon SES,
                   which is part of the same service.</p>
                <p>No other company receives your information. There is no AI assistant and nothing
                   you write is sent to a third party to be processed.</p>
            </section>

            <section class="form-section">
                <h2>How long it is kept</h2>
                <ul>
                    <li>Photos, videos and captions: until you or an administrator delete them.</li>
                    <li>An event's guest content: until the event is deleted.</li>
                    <li>Database backups: 7 days.</li>
                    <li>Server access logs, which include IP addresses: 3 months.</li>
                </ul>
            </section>

            <section class="form-section">
                <h2>Your rights</h2>
                <p>You can ask for a copy of what is held about you, ask for it to be corrected, or
                   ask for your account and its contents to be deleted. Email
                   <a href="mailto:rob@shanksfamily.net">rob@shanksfamily.net</a>, or see
                   <a href="/delete-account" data-link>deleting your account</a>.</p>
                <p>Under UK data protection law you may also complain to the Information
                   Commissioner's Office (<a href="https://ico.org.uk" target="_blank" rel="noopener">ico.org.uk</a>).</p>
            </section>

            <section class="form-section">
                <h2>Children</h2>
                <p>Children in the family appear in photos and may have their own account, set up and
                   managed by a parent. A parent can ask for a child's account or any photo of them to
                   be removed at any time.</p>
            </section>

            <section class="form-section">
                <h2>Changes</h2>
                <p>If this policy changes, the date at the top of this page changes with it.</p>
            </section>
        </div>`;
}
